import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import UserDocumentListModal from 'garaje/components/user-document-list/modal';
import dateFormat from 'garaje/helpers/date-format';
import type UserDocumentModel from 'garaje/models/user-document';

interface UserDocumentListItemSignature {
  Args: {
    userDocument: UserDocumentModel;
  };
  Element: HTMLTableRowElement;
}

export default class UserDocumentListItem extends Component<UserDocumentListItemSignature> {
  @tracked isOpen = false;

  get status(): string {
    const { userDocument } = this.args;
    return userDocument.isExpired ? 'Expired' : userDocument.userDocumentLink?.formattedApprovalStatus ?? '';
  }

  get lowerStatus(): string {
    return this.status.toLowerCase();
  }

  toggleOpen = (): void => {
    this.isOpen = !this.isOpen;
  };

  <template>
    <tr data-test-user-document-listing={{@userDocument.id}} ...attributes>
      <td class="py-4 px-0 border-b">
        {{#if @userDocument.isExpired}}
          {{@userDocument.title}}
          has
          <span class="text-black font-bold">
            {{this.lowerStatus}}
          </span>
        {{else if @userDocument.isApproved}}
          {{@userDocument.title}}
          has been
          <span class="text-black font-bold">
            {{this.lowerStatus}}
          </span>
        {{else if @userDocument.isDenied}}
          An admin has
          <span class="text-black font-bold">
            requested
          </span>
          the
          {{@userDocument.title}}
          to be
          <span class="text-black font-bold">
            resubmitted
          </span>
        {{else if @userDocument.isReview}}
          {{@userDocument.title}}
          uploaded and
          <span class="text-black font-bold">
            {{this.lowerStatus}}
          </span>
        {{else}}
          Uploaded a
          <span class="text-black font-bold">
            {{this.lowerStatus}}
          </span>
          {{@userDocument.title}}
        {{/if}}
      </td>
      <td class="text-right py-4 px-2 border-b">
        {{dateFormat @userDocument.sortableDate "MMMM do, yyyy"}}
      </td>
      <td class="text-right py-4 px-2 border-b">
        <button data-test-view-user-document type="button" class="text-gem-50" {{on "click" this.toggleOpen}}>
          View
        </button>
      </td>
    </tr>
    {{#if this.isOpen}}
      <UserDocumentListModal @toggleOpen={{this.toggleOpen}} @userDocument={{@userDocument}} />
    {{/if}}
  </template>
}
